export const action = function (type, payload = {}) {
  return { type, ...payload };
};
